import { sameId } from '../../../shared/api/wire'
import type { AqsiSale } from './types'

/**
 * Какую продажу отдать подготовке оплаты после сохранения корзины (К-122): правда — ответ службы на сохранение (`saved`), а не кэш
 * активной продажи. Кэш пишет опрос раз в секунду, и ответ опроса, начатого ДО сохранения, приходит ПОСЛЕ него и кладёт в кэш прежний
 * способ оплаты; принудительное чтение тоже присоединяется к уже идущему опросу и возвращает старое. Поэтому: кэш новее или тот же —
 * кэш; иначе — сохранённая продажа.
 */
export function saleAfterSave(cached: AqsiSale | null, saved: AqsiSale | undefined): AqsiSale | null {
  if (saved === undefined || saved.isFinished || saved.isParked) return cached
  if (cached === null || !sameId(cached.id, saved.id) || cached.version < saved.version) return saved
  return cached
}

/**
 * Служба вернула продажу с прежним способом оплаты — отказ словами экрана; `null` — способ применён. Про «обновите службу» речи нет:
 * текущая служба это поле знает, а версию клиент не проверял — прежний текст с номером версии вводил в заблуждение (К-122).
 */
export function paymentKindRefusal(sale: AqsiSale, kind: AqsiSale['paymentKind']): string | null {
  if (sale.paymentKind === kind) return null
  return 'Служба кассы не сменила способ оплаты: в её ответе прежний способ. Нажмите «Повторить»; если повторится — скопируйте ошибку и сообщите администратору. Деньги не списаны.'
}
